import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import magidLogo from "./assets/magid-logo.png";
import Home from "./pages/home";
import Simulator from "./pages/simulator";
import Header from "./components/Header";
import Blender from "./pages/blender";

import InitializeGoogleAnalytics from "./components/Tracker";
// import Snow from "./components/Snow";

InitializeGoogleAnalytics();

function App() {
  return (
    // <div className="App bg-[#8C5F49] bg-opacity-60">
    <div className="App">
      <Router basename={process.env.REACT_APP_ROUTER_BASENAME}>
        <div
          className="absolute top-0 
                          right-4 lg:right-28 
                          w-16 md:w-20"
        >
          <img src={magidLogo} alt="Magid" />
        </div>

        {/* <div className='fixed -top-20'>
          <Snow />
        </div> */}

        <div>
          <Header />
        </div>
        <Routes>
          <Route path="/" element={<Blender />} />
          <Route path="/home" element={<Home />} />
          <Route path="/simulator" element={<Simulator />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
